import { h } from "preact";
import ProductList from "../helpers/product-list/product-list";
import { TABS } from "./constants";

export default function SearchProductResults({
  ids,
  setProductCount,
  setProductsLoading,
  loading,
  activeTab,
  translations,
}) {
  // Just hide when inactive to avoid re-fetching products when flipping between tabs
  const style = activeTab === TABS.products ? {} : { display: "none" };

  if (!ids) return null;

  return (
    <div
      role="tabpanel"
      aria-labelledby={`search-tab-${TABS.products}`}
      style={style}
    >
      {!ids.length && !loading ? (
        <div className="main-search__no-item-results">
          {translations.product_no_results}
        </div>
      ) : (
        <div
          className={`main-search__product-results ${
            loading ? "main-search__product-results--loading" : ""
          }`}
        >
          <ProductList
            ids={ids}
            setTotalProductsCount={setProductCount}
            setLoading={setProductsLoading}
            cardStyle="gradient"
          />
        </div>
      )}
    </div>
  );
}
